import React from 'react';
import Tooltip from './Tooltip';
import MediaImg from './MediaImg';
import './TypeFilterGroup.css';

/**
 * One filter category as a row of item-type toggles.
 *
 * Weapons no longer come through here as a group of their own: eleven types
 * was too many for a row, and they have a dropdown (`WeaponTypeFilter`), which
 * renders its contents with this. Every other category is a handful of icons
 * and says everything it has to say in a line.
 */
const TypeFilterGroup = ({
    types,
    typeFilters,
    onToggleTypeFilter,
    lang = 'fr',
    /** Let the icons wrap — for a caller that gives them a box, not a row. */
    wrap = false,
}) => (
    <div className="gen-conf-slot-group row">
        <div className={`genconf-icon-btn-row row${wrap ? ' genconf-icon-btn-row--wrap' : ''}`}>
            {types.map((type) => {
                const isActive = typeFilters[type.id];
                return (
                    <Tooltip key={type.id} content={type.name[lang]}>
                        <button
                            type="button"
                            className={`genconf-icon-btn alt ${isActive ? 'active' : ''}`}
                            onClick={() => onToggleTypeFilter(type.id)}
                        >
                            <MediaImg
                                src={type.img}
                                className="genconf-icon"
                                alt={type.name[lang]}
                                fallback=""
                            />
                        </button>
                    </Tooltip>
                );
            })}
        </div>
    </div>
);

export default TypeFilterGroup;
